import { ApuCategoryApiModel } from '@/core/models/api/apu-category-api.model';
import { ApuCategoryTypeApiModel } from '@/core/models/api/apu-category-type-api.model';
import { ApuResourceApiModel } from '@/core/models/api/apu-resource-api.model';
import { TenderApiModel } from '@/core/models/api/tender-api-model.model';

export interface TenderSaleState {
  tender: TenderApiModel | null;
  loadingTender: boolean;
  apuId: number | null;
  categoryTypes: ApuCategoryTypeApiModel[];
  selectedApuCategory: ApuCategoryApiModel | null;
  selectedResources: ApuResourceApiModel[];
  loading: boolean;
  loadingResources: boolean;
  errorMessage: string | null;
}

export const initialTenderSaleState: TenderSaleState = {
  tender: null,
  loadingTender: false,
  apuId: null,
  categoryTypes: [],
  selectedApuCategory: null,
  selectedResources: [],
  loading: false,
  loadingResources: false,
  errorMessage: null,
};
